import { useCallback, useEffect, useContext, memo } from 'react'

import { TtsItemContext } from 'containers/SubSidebar/TtsContent/List/Item/contextApi'
import { TtsItemSpeakerFlyoutContext } from 'containers/SubSidebar/TtsContent/List/Item/SpeakerFlyout/contextApi'
import { TTS_LANGUAGE_ITEM_CLASS_NAME } from '../../../consts'
import LanguageDropdown from 'containers/SubSidebar/TtsContent/components/LanguageDropdown'
import { useSelector } from 'react-redux'
import { ttsThunks } from 'store/features/tts/thunks'
import { ttsSelectors } from 'store/features/tts/selectors'
import { dispatch } from 'store'

const TtsItemLanguageDropdown: React.FC = () => {
  const { ttsItemLangCode, handleLanguageChange, handleVoiceChange } =
    useContext(TtsItemSpeakerFlyoutContext)

  const { scrollableParentRef } = useContext(TtsItemContext)
  const ttsLangOptions = useSelector(ttsSelectors.languageOptionsData)
  const isLanguageOptionsLoading = useSelector(
    ttsSelectors.isLanguageOptionsLoading
  )

  const handleTtsLanguageClick = useCallback(
    (langCode: string | number) => {
      if (langCode === ttsItemLangCode) return

      handleLanguageChange(langCode as string)
      dispatch(
        ttsThunks.getSpeakersPerLangCode(langCode as string, speakerId => {
          handleVoiceChange(speakerId)
        })
      )
    },
    [ttsItemLangCode, handleLanguageChange, handleVoiceChange]
  )

  useEffect(() => {
    if (!ttsLangOptions?.length) {
      dispatch(ttsThunks.getLanguageOptions())
      dispatch(ttsThunks.getSpeakersPerLangCode(ttsItemLangCode))
    }
  }, [ttsLangOptions, isLanguageOptionsLoading, ttsItemLangCode])

  return (
    <LanguageDropdown
      languageOptions={ttsLangOptions}
      selectedLanguageId={ttsItemLangCode}
      isDataLoading={isLanguageOptionsLoading}
      onLanguageChange={handleTtsLanguageClick}
      scrollableParentRef={scrollableParentRef}
      childClassName={TTS_LANGUAGE_ITEM_CLASS_NAME}
    />
  )
}

export default memo(TtsItemLanguageDropdown)
